import { render, staticRenderFns } from "./ButtonsMessage.vue?vue&type=template&id=8836bb3e&scoped=true&"
import script from "./ButtonsMessage.vue?vue&type=script&lang=js&"
export * from "./ButtonsMessage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsMessage.vue?vue&type=style&index=0&id=8836bb3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8836bb3e",
  null
  
)

export default component.exports